import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function campaignsLoadRequest(urlParams, isPsf = false) {
  return request({
    method: 'get',
    url: isPsf ? urls.campaignsListFiltered : urls.campaignsList,
    urlParams,
    headers: getHeaders(),
  });
}

export async function campaignLoadRequest(urlParams) {
  return request({
    method: 'get',
    url: urls.campaignItem,
    urlParams,
    headers: getHeaders(),
  });
}

export async function campaignCreateRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.campaignCreate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function campaignUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.campaignUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function campaignRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.campaignRemove,
    urlParams,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/campaigns.js